<template>
  <div>
    <section class="contact white mt-5">
      <b-container>
        <div class="row">
          <div class="col-md-7">
            <div class="contact-info" style="margin-top: 0in">
              <form v-on:submit.prevent="SaveForm">
                <div class="row">
                  <div class="form-group col-sm-6" data-aos="fade-right">
                    <input
                      type="text"
                      required
                      v-model="name"
                      placeholder="Name*"
                      class="form-control"
                      style="width: 95%;"
                    />
                  </div>
                  <div class="form-group col-sm-6" data-aos="fade-left">
                    <input
                      type="email"
                      v-model="email"
                      placeholder="Email"
                      class="form-control"
                    />
                  </div>
                  <div class="form-group col-sm-12" data-aos="fade-right">
                    <input
                      type="number"
                      required
                      v-model.number="mobile"
                      placeholder="Phone Number *"
                      class="form-control"
                    />
                  </div>
                  <div class="form-group col-sm-12" data-aos="fade-right">
                    <textarea
                      name="message"
                      required
                      placeholder="Message*"
                      v-model="message"
                      style="height: 279px"
                      class="form-control"
                      rows="10"
                    ></textarea>
                  </div>
                  <div class="col-sm-12">
                    <button type="submit" class="btn btn-primary">
                      Contact
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="col-md-5">
            <div class="footer-addess">
              <p class="mar-1 mar-top-20">
                Address:- <br />LEVEL 17, SPACES MAX TOWER, Sector 16B, Noida,
                Uttar Pradesh 201301
              </p>
            </div>
          </div>
        </div>
      </b-container>
    </section>
  </div>
</template>

<script>
import { dbFs } from "@/modules/database";
export default {
  data() {
    return {
      name: "",
      email: "",
      mobile: "",
      message: ""
    };
  },
  methods: {
    SaveForm() {
      dbFs
        .collection("contactForm")
        .add({
          name: this.name,
          email: this.email,
          mobile: this.mobile,
          message: this.message
        })
        .then(() => {
          this.name = "";
          this.email = "";
          this.mobile = "";
          this.message = "";
          alert("Successful Done");
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
